import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';

const renderPic = (props) => {
  return props.formattedValue ? (
    <img
      className="avatar"
      src={props.formattedValue}
      alt={props.row.speaker}
    />
  ) : (
    <div className="fake-avatar">
      <FontAwesomeIcon icon={faUser} />
    </div>
  );
};
const fullListCols = [
  {
    field: 'index',
    headerName: 'Rank in session',
    width: 40,
  },
  {
    field: 'assigned_slot',
    headerName: 'Assigned Slot',
    width: 120,
  },
  { field: 'participation', headerName: 'Participation', width: 120 },
  { field: 'country', headerName: 'Country', width: 200 },
  {
    field: 'administration',
    headerName: 'Administration',
    width: 250,
  },
  { field: 'organisation', headerName: 'Organisation', width: 250 },
  { field: 'speaker', headerName: 'Speaker', width: 300 },
  { field: 'speaker_title', headerName: 'Title', width: 200 },
  {
    field: 'submission_date',
    headerName: 'Submission date',
    width: 120,
  },
  {
    field: 'preferred_date',
    headerName: 'Preferred date',
    width: 120,
  },
  {
    field: 'second_choice',
    headerName: 'Second choice',
    width: 120,
  },
  { field: 'third_choice', headerName: 'Third choice', width: 120 },
  { field: 'contact', headerName: 'Contact', width: 300 },
  {
    field: 'contact_title',
    headerName: 'Contact title',
    width: 200,
  },
  {
    field: 'contact_email',
    headerName: 'Contact email',
    width: 170,
  },
  {
    field: 'contact_phone',
    headerName: 'Contact phone',
    width: 170,
  },
];
const chairListCols = [
  {
    field: 'index',
    headerName: 'Rank in session',
    width: 40,
  },
  {
    field: 'country',
    headerName: 'Country',
    width: 150,
  },
  { field: 'speaker', headerName: 'Speaker', width: 300 },
  { field: 'speaker_title', headerName: 'Title', width: 380 },
  {
    field: 'administration',
    headerName: 'Administration',
    width: 250,
  },
  { field: 'assigned_slot', headerName: 'Assigned Slot', width: 120 },
];
const picsListCols = [
  {
    field: 'index',
    headerName: 'Rank in session',
    width: 40,
  },
  {
    field: 'country',
    headerName: 'Country',
    width: 200,
  },
  {
    field: 'picture',
    headerName: 'Picture',
    width: 150,
    renderCell: renderPic,
  },
  { field: 'speaker', headerName: 'Speaker', width: 300 },
  { field: 'speaker_title', headerName: 'Title', width: 200 },
  { field: 'administration', headerName: 'Administration', width: 400 },
  { field: 'assigned_slot', headerName: 'Assigned Slot', width: 120 },
  { field: 'participation', headerName: 'Participation', width: 120 },
];
const simpleListCols = [
  { field: 'assigned_slot', headerName: 'Assigned Slot', width: 200 },
  { field: 'country', headerName: 'Country', width: 300 },
];

export { fullListCols, chairListCols, picsListCols, simpleListCols };
